module.exports = __webpack_public_path__ + "static/img/mingf14.e0585f9e.png";